module.exports = __webpack_public_path__ + "img/role03.f36c41da.png";